import React from 'react';
import { useSelector } from 'react-redux';
import { Dialog } from 'src/components/shared/dialog/Dialog';
import { resortInfoSelector } from '../../selectors/resortInfoSelector';
import { ReportMenuContent } from './ReportMenuContent';

interface ReportMenuDialogProps {
  basePath: string;
}

export const ReportMenuDialog: React.FC<ReportMenuDialogProps> = ({ basePath }) => {
  const infoState = useSelector(resortInfoSelector);

  if (infoState?.state !== 'ok') {
    return <></>;
  }

  const { profile, isFollowing } = infoState.result;

  return (
    <Dialog hasHeader={true}>
      <ReportMenuContent basePath={basePath} profile={profile} isFollowing={isFollowing} />
    </Dialog>
  );
};
